<template>
  <div class="special-compare-value">
    <normal-select
      v-if="control._type === 'check'"
      :select-list="checkMethods"
      :selectedItem.sync="checkCompareMethod"
      @update:selectedItem="emitVal"
      class="check"
    ></normal-select>
    <el-date-picker
      v-else-if="control._type === 'time'"
      v-model="timeRange"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      align="right"
      class="time"
      popper-class="quick-date"
      value-format="yyyy-MM-dd HH:mm:ss"
      @change="emitVal"
    ></el-date-picker>
    <number-range
      v-else
      class="number"
      :number-range="numberRange"
      @clear="clearNumber"
    ></number-range>
  </div>
</template>

<script>
import NumberRange from "@/components/Sheet/QuickSearch/NumberRange"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { checkMethods } from "@/components/Sheet/FieldSearch/static"
import { quickTimeRange } from "@/components/Sheet/QuickSearch/static"
import { getFilter } from "@/utils/sheet"
import dj from "dayjs"

export default {
  name: "special-compare-value",
  components: { NormalSelect, NumberRange },
  props: { control: Object, compareMethod: Array },
  data() {
    return {
      quickTimeRange,
      checkMethods,
      timeRange: [],
      numberRange: [null, null],
      djFormat: "YYYY-MM-DD HH:mm:ss",
      checkCompareMethod: ""
    }
  },
  computed: {
    pickerOptions() {
      return this.getOptions()
    }
  },
  methods: {
    getOptions() {
      let result = []
      this.quickTimeRange.forEach(timeRange => {
        let timeInfo = this.fastIntervalCompute(timeRange.value, new Date())
        let option = {
          text: timeRange.label,
          onClick(picker) {
            picker.$emit("pick", [timeInfo.beginTime, timeInfo.endTime])
          }
        }
        result.push(option)
      })
      return { shortcuts: result }
    },
    fastIntervalCompute(value, time) {
      let result = {}
      let unit = value.split("-")[1]
      let method = value.split("-")[0]
      switch (method) {
        case "last":
          time = dj(time).subtract(1, unit)
          break
        case "next":
          time = dj(time).add(1, unit)
          break
      }
      if (unit === "week") {
        result.beginTime = dj(time)
          .startOf(unit)
          .add(1, "day")
          .format(this.djFormat)
        result.endTime = dj(time)
          .endOf(unit)
          .add(1, "day")
          .format(this.djFormat)
      } else {
        result.beginTime = dj(time)
          .startOf(unit)
          .format(this.djFormat)
        result.endTime = dj(time)
          .endOf(unit)
          .format(this.djFormat)
      }
      return result
    },
    clearNumber() {
      this.numberRange = [null, null]
      this.emitVal()
    },
    emitVal() {
      this.$emit("input")
    },
    getFilters(control) {
      let result = []
      if (control._type === "check") {
        if (this.checkCompareMethod) {
          result.push(getFilter(control, this.checkCompareMethod, []))
        }
      } else if (control._type === "time") {
        let startTime = this.timeRange[0] ? dj(this.timeRange[0]).format("YYYY-MM-DD HH:mm:ss") : ""
        let endTime = this.timeRange[1] ? dj(this.timeRange[1]).format("YYYY-MM-DD HH:mm:ss") : ""
        if (startTime)
          result.push(getFilter(control, this.compareMethod[0], [{ var: false, value: startTime }]))
        if (endTime)
          result.push(getFilter(control, this.compareMethod[1], [{ var: false, value: endTime }]))
      } else {
        let min = this.numberRange[0]
        let max = this.numberRange[1]
        if (min !== undefined)
          result.push(getFilter(control, this.compareMethod[0], [{ var: false, value: min }]))
        if (max !== undefined)
          result.push(getFilter(control, this.compareMethod[1], [{ var: false, value: max }]))
      }
      return result
    },
    clear() {
      this.timeRange = []
      this.numberRange = [null, null]
      this.checkCompareMethod = ""
    }
  }
}
</script>

<style lang="scss" scoped>
.special-compare-value {
  .time {
    height: 32px;
    ::v-deep {
      .el-range__icon {
        line-height: 24px;
      }
      .el-range-separator {
        line-height: 24px;
      }
      .el-range__close-icon {
        line-height: 24px;
      }
    }
  }
}
</style>

<style lang="scss">
.quick-date {
  width: 624px !important;
  line-height: 10px !important;
  .el-picker-panel__sidebar {
    padding-bottom: 40px;
  }
  .el-picker-panel__icon-btn {
    margin-top: 0 !important;
  }
}
</style>
